const observatory = [
	{
		path: '/observatory/intelligence',
		name: 'observatory-intelligence',
		component: () => import('@/views/observatory/intelligence.vue'),
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/organizations',
		name: 'observatory-organizations-list',
		component: () => import('@/views/observatory/organizations/list.vue'),
		// MGN, e nao um short_name proprio: a linha do Observatorio em
		// mg_network_systems foi deliberadamente adiada — o nome do produto ainda nao
		// esta decidido e short_name e chave, nao rotulo. Ate la, conceder acesso a
		// cliente do Observatorio e administracao da REDE, e o modulo reflete isso.
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/access-requests',
		name: 'observatory-access-requests-list',
		component: () => import('@/views/observatory/access-requests/list.vue'),
		// Mesmo modulo das organizacoes: o pedido de acesso e o comeco do mesmo trabalho
		// (conversar, depois provisionar), feito pela mesma gente. Modulo novo exigiria
		// semear ACL so para repetir a mesma permissao.
		//
		// Esta rota foi removida por engano quando as telas de inteligencia entraram
		// (85da611c) e o item de menu continuou apontando para ela: a fila de pedidos de
		// acesso, unica entrada de demanda inbound do Observatorio, ficou inalcancavel.
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/professional-introductions',
		name: 'observatory-professional-introductions',
		component: () => import('@/views/observatory/professional-introductions.vue'),
		// Mesmo modulo do resto do Observatorio. O servico e quem decide: a fila so responde a admin_master, e responde 404
		// enquanto o diretorio de profissionais estiver desligado — a tela diz isso, e nao esconde a rota.
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/precedence',
		name: 'observatory-precedence',
		component: () => import('@/views/observatory/precedence.vue'),
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/applications',
		name: 'observatory-applications',
		component: () => import('@/views/observatory/applications.vue'),
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/entity-claims',
		name: 'observatory-entity-claims',
		component: () => import('@/views/observatory/entity-claims.vue'),
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/experiments',
		name: 'observatory-experiments',
		component: () => import('@/views/observatory/experiments.vue'),
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/events',
		name: 'observatory-events',
		component: () => import('@/views/observatory/events.vue'),
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
	{
		path: '/observatory/demo',
		name: 'observatory-demo',
		component: () => import('@/views/observatory/demo.vue'),
		// Mesmo modulo do resto do Observatorio. Quem decide e o servico: so admin_master passa, e ele responde 404 enquanto o modo
		// demonstracao estiver desligado no ambiente — a tela diz isso, e nao esconde a rota.
		meta: { layout: 'content', module: 'MGN,observatory-organizations' },
	},
]

export default observatory
